module.exports = __webpack_public_path__ + "static/media/Kristián-Vánoce-167x300.e8230e8f.jpg";